import React from 'react';

const ArrowBack = ({ size = 9, color = '#FFFEFE' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 8 9"
      fill="none"
    >
      <g clipPath="url(#clip0_4926_128503)">
        <path
          d="M4.59859 8.04071L4.20221 8.43709C4.03437 8.60493 3.76297 8.60493 3.59692 8.43709L0.125879 4.96783C-0.0419596 4.8 -0.0419596 4.5286 0.125879 4.36255L3.59692 0.891504C3.76476 0.723665 4.03616 0.723665 4.20221 0.891504L4.59859 1.28789C4.76822 1.45751 4.76465 1.73427 4.59145 1.90032L2.43991 3.95009H7.57148C7.80895 3.95009 8 4.14114 8 4.37861V4.94998C8 5.18745 7.80895 5.3785 7.57148 5.3785H2.43991L4.59145 7.42827C4.76643 7.59433 4.77 7.87108 4.59859 8.04071Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4926_128503">
          <rect width="8" height="9" fill="white" transform="translate(0 0.664062)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowBack;
